import React, { useState } from "react";
import "./styles.scss";

const Switch = ({
  checked,
  defaultChecked,
  onChange,
  label,
  labelPosition = "top",
}) => {

  return (
    <div
      style={{
        display: "flex",
        flexDirection: labelPosition === "left" ? "row" : "column",
        gap: "10px",
      }}
    >
      {label && <label className="">{label}</label>}
      <label className="switch">
        {checked !== undefined && (
          <input
            checked={checked}
            onChange={(event) => {
              // event.persist();
              onChange(event);
            }}
            type="checkbox"
          />
        )}

        {defaultChecked !== undefined && (
          <input
            defaultChecked={defaultChecked}
            onChange={(event) => {
              // event.persist();
              onChange(event);
            }}
            type="checkbox"
          />
        )}

        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default Switch;
